<div class='quick-link'>
  @if (!isLoading) {
    <a href="javascript:void(0)" (click)="submitForm();" class="external-link">
      {{ label || 'Enroll - Connecture' }}
      <span class="material-symbols-outlined">open_in_new</span>
    </a>
  }
  @if (isLoading) {
    <mat-spinner diameter="25"></mat-spinner>
  }
</div>